export default __webpack_public_path__ + "media/images/lp/howto-pc-1ec9aaf4d80e3b6032441819685f6a19.jpg";